<template>

    <v-chip class="user-activity__money-chip">

        <MoneyIcon />
        <span class="user-activity__money-chip__redeem-amount">+
            <slot></slot>
        </span>


    </v-chip>

</template>



<script setup>
import MoneyIcon from '@/icons/Money.vue';
</script>